<div class="navbar-wrapper" [ngClass]="{'container': this.gradientConfig.layout === 'horizontal' && this.gradientConfig.subLayout === 'horizontal-2'}">
    <app-nav-content  *ngIf="showNavContent && !isScreenAbove900"  ></app-nav-content>
    <app-nav-content *ngIf="isScreenAbove900"></app-nav-content>
</div>